import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import { LessonComponentResultPanel } from './LessonComponentResultPanel';
import { NonAutoMarkComponent } from '../../content/models/LessonComponent';
import React from 'react';
import { Typography } from '@mui/material';
import { isNil } from 'lodash';
import styles from '../styles/LessonComponentSubmissionPanel.module.css';
import { useLessonComponentContext } from '../models/LessonComponentContext';
import { useLessonContext } from '../models/LessonContext';

interface NonAutoMarkingSubmissionPanelProps {
  points: number;
  assignedPoints: number;
  component: NonAutoMarkComponent;
}

export const NonAutoMarkingSubmissionPanel = (
  props: NonAutoMarkingSubmissionPanelProps
) => {
  const responsePattern = props.component.answer || null;
  const { finalized, quizLocked, assessmentSubmitted, portfolioLocked } =
    useLessonContext();
  const {
    correct,
    fullMark,
    reattempt,
    answerSaved,
    handleReattempt,
    handleSubmit
  } = useLessonComponentContext();

  const showEditAnswer =
    !finalized && !quizLocked && !assessmentSubmitted && !fullMark;

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      {correct &&
        (!reattempt || finalized) &&
        (showEditAnswer ||
          (props.component.settings.survey && showEditAnswer)) && (
          <Grid className={styles.submissionPanel}>
            <Button
              color="secondary"
              variant="contained"
              onClick={handleReattempt}
              disabled={portfolioLocked}
            >
              Edit Answer
            </Button>
          </Grid>
        )}
      {(isNil(correct) || reattempt) &&
        (showEditAnswer ? (
          <>
            {props.assignedPoints > 0 &&
              !answerSaved &&
              !props.component.settings.survey && (
                <Grid className={styles.points}>
                  <Typography
                    display="inline"
                    variant="subtitle2"
                    align="center"
                  >
                    {`This question is worth ${props.assignedPoints} point${
                      props.assignedPoints > 1 ? 's' : ''
                    }`}
                  </Typography>
                </Grid>
              )}
            {props.component.type !== 'file_uploader' && (
              // File uploader doesn't require "Save and continue" button. It uploads file
              // directly to cloud when "upload" button is clicked on the upload dialog
              <Grid className={styles.submissionPanel}>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={isNil(responsePattern)}
                  onClick={handleSubmit}
                >
                  Save and Continue
                </Button>
              </Grid>
            )}
          </>
        ) : (
          isNil(responsePattern) &&
          props.component.type !== 'file_uploader' && ( // File uploader has it's own feedback
            <Grid className={styles.submissionPanel}>
              <LessonComponentResultPanel message="You didn't answer this question" />
            </Grid>
          )
        ))}
    </Grid>
  );
};
